import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useModal } from "./ModalManager";
import { deleteThread, addThreadParticipants } from "../api/ChatThreadsAPI";

export default function ConversationOptionsModal({ token, threadId, onClose, onEdit }) {
  const navigate = useNavigate();
  const { openModal } = useModal();
  // const [ participants, setParticipants] = useState([]);

  const handleDelete = async () => {
    try {
      const data = await deleteThread(threadId, token);
      // navigate back to /messages
      window.location.href = "/messages/";
    } catch (err) {
      console.error("Failed to delete conversation", err);
    }
  };

  const handleInvite = async (participants) => {
    if (!participants) return;
    try {
      const data = await addThreadParticipants(threadId, participants, token);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      className="bg-white rounded-t-lg sm:rounded-lg w-full sm:w-96 p-4 space-y-4 shadow-lg"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={() => openModal("UserSelectModal", { token: token, onSend: handleInvite })}
        className="w-full py-2 border-b"
      >
        Add Participants
      </button>
      <button
        className="w-full py-2 border-b"
        onClick={() => {
          onEdit();
          onClose();
        }}
      >
        Edit Chat Name
      </button>
      <button className="w-full py-2 border-b">Mute</button>
      <button className="w-full py-2 border-b">Report</button>
      <button onClick={handleDelete} className="w-full py-2 border-b text-red-500">
        Delete
      </button>
      <button onClick={onClose} className="w-full py-2 font-semibold text-gray-700">
        Cancel
      </button>
    </div>
  );
}
